import { StandardInfo } from "../../../modules/Utilities/ConfigureAgreement/Standard/type/StandardInterface";
import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

// Get Standard
export const getStandard = async () => {
  const { data } = await axios.get(`${api_base_url}/AgreementStandard`);
  return data;
};

// Update Standard

export const updateStandard = async (updatedStandardData: StandardInfo) => {
  const { data } = await axios.put(
    `${api_base_url}/AgreementStandard/${updatedStandardData.standardId}`,
    updatedStandardData
  );
  return data;
};

//Insert New Standard
export const addStandard = async (newStandard) => {
  const { data } = await axios.post(`${api_base_url}/AgreementStandard`, {
    ...newStandard,
  });
  return data;
};

//Delete Standard
export const deleteStandard = async (StandardIds) => {
  await axios.delete(`${api_base_url}/AgreementStandard/bulkDelete`, {
    data: StandardIds,
  });
};
